import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAudio: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="audio, music, playlist, musical-note"><path d="M9.75 18.75C9.75 20.1307 8.40685 21.25 6.75 21.25C5.09315 21.25 3.75 20.1307 3.75 18.75C3.75 17.3693 5.09315 16.25 6.75 16.25C8.40685 16.25 9.75 17.3693 9.75 18.75ZM9.75 18.75V5.75L20.2522 2.75V15.75M20.2522 15.75C20.2522 17.1307 18.9091 18.25 17.2522 18.25C15.5953 18.25 14.2522 17.1307 14.2522 15.75C14.2522 14.3693 15.5953 13.25 17.2522 13.25C18.9091 13.25 20.2522 14.3693 20.2522 15.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAudio;
